/*Recurso: Dashboard  Variables y rutinas store que almacenan la respuesta del API y su manipulación en el front
  Tareas:
    GetSummarybyUser/{lang}
    GetDetailbyUser/{lang}
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import { fn } from "jquery";
import create from "zustand";

const dashboardStore = create((set:any, get:any) => ({

  objErrorDashboardStore: { hasError: false, url: '', body:'',  recurso:"dashboard", componente:'', idresul: 0, desresul:'', menu:''}, //se llena con la información del api si éste tiene error

    //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI  
    limpiaObjErrorDashboardStore: () => {
      let paso = { hasError: false, url:'', body:'', recurso:'dashboard', componente:'', idresul:0, desresul:'', menu:''}
      set( { objErrorDashboardStore: paso } );
      //console.log('limpiaObjErrorDashboardStore (sale) - objErrorDashboardStore: ', get().objErrorDashboardStore);
    },
                
    //*Error en api // entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
    generaObjErrorDashboardStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
      //console.log('*generaObjErrorDashboardStore (entra): ', responseAPI);
      //console.log('*generaObjErrorDashboardStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
      let paso = { hasError: h, url:'', body:e, recurso:'dashboard', componente:c, idresul:0, desresul:'', menu:m };
      if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
          paso.idresul=-1;
          paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
      }
      else if (responseAPI=='Error detectado por api en ret') {
        paso.desresul= h;
        paso.idresul= h2; 
      }
      else {
        let temp = responseAPI.config;
        paso.url = temp.url;
        if (responseAPI.data!="" && responseAPI.data!=null){
          //console.log('paso2');
            paso.idresul=responseAPI.data.ret;
            paso.desresul= responseAPI.data.msjerror;
        }    
        else {
            paso.idresul= responseAPI.status;
            switch(responseAPI.status){
              //case 404:  paso.desresul= "El usuario no existe"; break;
              case 401:  paso.desresul= "No autorizado"; break;
              case 404:  paso.desresul= "No tiene información, error al leer la tarea del API"; break;
              default: paso.desresul= responseAPI.statusText; break;
            }
        }    
      }
      set( { objErrorDashboardStore: paso } );
      //console.log('::DashboardStore - generaObjErrorDashboardStore (sale) - objErrorDashboardStore: ', get().objErrorDashboardStore);
    },

  pfcStore: [],  //guarda la lista de los procesos/frecuencia/ciclo completa sin agrupar por dominio
  pfcDominioStore: [],  //guarda la lista de los procesos/frecuencia/ciclo completa agrupada por dominio

      //*Tareas: GetSummarybyUser  // lista de procesos/frecuencia/ciclo 
      guardaGetSummarybyUserStore: async (responseAPI:any) => { 
        //console.clear();
        //console.log('guardaGetSummarybyUserStore - responseAPI:', responseAPI)
        //console.log('guardaGetSummarybyUserStore - catD:', catD)
        var _ = require('underscore');
        if (responseAPI.ret==1) { //sin error

            let pfcPaso=  responseAPI.item;

            pfcPaso.map((pfc:any) => {
                pfc.abierto = false; //por omisión entra cerrado //*pfc.isCollapse
                pfc.pfcNombre = pfc.acronym + ' / ' + pfc.frequencyname + ' / ' + pfc.cyclename; //*pfc.acronymfrequencycicle // c.acronymfrequencycicle.toUpperCase().includes(page.inputValue.toUpperCase())
                pfc.numEvidence = pfc.evidence.length;

                let paso = pfc.state_process;
                pfc.estatusProceso = paso.pt_state_description;
                pfc.clasexEstatusIcono = "";
                switch ( paso.pt_state ) {
                  case 1: pfc.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                  case 2: pfc.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                  case 3: pfc.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                  case 4: pfc.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                  default: pfc.clasexEstatusIcono= "claseEstatus claseEstatusAct"; break;
                }
                //*Decision Prevista / No prevista
                  //en el encabezado del cuadro los artículos son diferentes para Prevista y no prevista, sin embargo el arreglo puede traer las dos
                  //si es el caso los encabezados llevaron los artículos de la No prevista
                  //pueden venir así decision: [2], decision: [3], decision: [2,3] **nunca vacío
                  let swPrevista = false;
                  let swNoPrevista = false;
                  if (pfc.decision.length == 1) { pfc.swDecision = pfc.decision[0] }
                  else {
                      pfc.decision.map((dec:any, indexDec:any) => {
                          if (dec == 2) { swPrevista = true }
                          if (dec == 3) { swNoPrevista = true }
                      });
                      if (swPrevista)   { pfc.swDecision = 2 }
                      if (swNoPrevista) { pfc.swDecision = 3 } //si el arreglo trae no prevista éste será el que se visualiza
                  }
                  if (swPrevista && swNoPrevista) { pfc.swDecision = 23} //asignado solo para control de los dos elementos
                //*
                //lo ocupa para agregar el letro cuando se uso el filtro 
                if (pfc.sent) {  pfc.textoSent = 'Concluida'; }
                else { pfc.textoSent = 'En proceso de documentación' }
               
            });
            
            set ( { pfcStore: pfcPaso } );
            //console.log ('---------:::::::::pfcStore: ',  get().pfcStore );
            //generamos pfcDominioStore // genera agrupación por pfc
            get().generaPfcDominioStore (pfcPaso);
       
            return(get().pfcDominioStore);
        }
        else {
            get().generaObjErrorDashboardStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'dashboard.store-guardaGetSummarybyUserStore')
        }
      },

      generaPfcDominioStore: async ( pfcArreglo: any ) => {

        //agrupamos por dominio
          var _ = require('underscore');
          let pfcPasoD =  _.groupBy(pfcArreglo, 'domainname'); 
          let claves = Object.keys(pfcPasoD); // claves = ["nombre dominio", "nombre dominio", "nombre dominio", ... ];
          let pfcArray = [];
          let pfcArrayElem:any = { 'id':0, 'dominio':'', 'abierto':true, 'arreglo':[], 't':0, 'e':0, 'c':0 };
          let clave = '';
          for (let i = 0; i < claves.length; i++) {
              pfcArrayElem = { 'id':0, 'dominio':'', 'abierto':true, 'arreglo':[], 't':0, 'e':0, 'c':0 };
              clave = claves[i];
              pfcArrayElem = { 'id': i, 'dominio':clave, 'abierto':true, 'arreglo': pfcPasoD[clave], 't':0, 'e':0, 'c':0 }
              pfcArray.push(pfcArrayElem);
          }
          //console.log('pfcArray...', pfcArray)
          get().pfcDominioStore = pfcArray;

        //variables para agrupar por pfc y dejar en pfc.arregloFiltrado
          let pfcArregloFiltradoPaso:any = {};  
          let arregloFiltrado:any = [];
          let arregloFiltradoE:any = [];
          let arregloFiltradoC:any = [];
          let arregloElemFiltrado:any = { 'id':0, 'pfcNombre':'', 'abierto':false, 'arreglo':[], 'arregloDetalles':[],'t':0, 'e':0, 'c':0  };
          let clavesFiltrado:any = {};
          let claveF = '';
        
        get().pfcDominioStore.map((pfc:any, indexPfc:any) => {
          //agrupamos pfc
          pfcArregloFiltradoPaso = {};  
          pfcArregloFiltradoPaso = _.groupBy(pfc.arreglo, 'pfcNombre'); 
          clavesFiltrado = Object.keys(pfcArregloFiltradoPaso); // claves = {"pfcNombre", "pfcNombre", "pfcNombre", ... };
          arregloFiltrado = [];
          arregloFiltradoE = [];
          arregloFiltradoC = [];
          let swDecisionPaso = 0;
          let objDecisionPaso = [];
          if (clavesFiltrado.length > 0) {
              swDecisionPaso = 0;
              objDecisionPaso = [];
              for (let i=0; i < clavesFiltrado.length; i++) {
                  arregloElemFiltrado = { 'id':0, 'pfcNombre':'', 'abierto':false, 'arreglo':[], 'arregloDetalles':[], swDecision:null, 't':0, 'e':0, 'c':0 };
                  claveF = clavesFiltrado[i];
                  objDecisionPaso = pfcArregloFiltradoPaso[claveF];

                  if (objDecisionPaso.length == 1) {swDecisionPaso = objDecisionPaso[0].swDecision }
                  else {
                      objDecisionPaso.map((objD:any, indexobjD:any) => {
                        if ( objD.swDecision == 0 )  { swDecisionPaso = objD.swDecision }
                        if ( objD.swDecision == 23 ) { swDecisionPaso = 23 }
                        if ( objD.swDecision == 2 && swDecisionPaso == 3) { swDecisionPaso = 23 }
                        if ( objD.swDecision == 3 && swDecisionPaso == 2) { swDecisionPaso = 23 }
                      });
                  }
                  //console.log('***objDecisionPaso',objDecisionPaso)
                 

                  arregloElemFiltrado = { 'id':i, 'pfcNombre':claveF, 'abierto':false, 'arreglo':pfcArregloFiltradoPaso[claveF], 'arregloDetalles':[],  swDecision:swDecisionPaso,  't':0, 'e':0, 'c':0  }
                  arregloFiltrado.push(arregloElemFiltrado);
              } 
              pfc.pfcAgrupado = arregloFiltrado;
          }
          //contamos Concluidas y En proceso a nivel dominio
          let contE = 0;
          let contC = 0;
         
          pfc.arreglo.map((arr:any, indexArr:any) => {
              if (arr.sent) { contC = contC + 1 }
              else { contE = contE + 1 }
          });
          pfc.e = contE; //sin agrupar
          pfc.c = contC; //sin agrupar
          pfc.t = pfc.arreglo.length; //total sin agrupadas
     

          //contamos Concluidas y En proceso a nivel pfc dentro de pfcAgrupado
          pfc.pfcAgrupado.map((pfcF:any, indexpfcF:any) => {
            contE = 0;
            contC = 0;
            pfcF.arreglo.map((pfcFArreglo:any, indexPfcFArreglo:any) => {
              if (pfcFArreglo.sent) { contC = contC + 1 }
              else { contE = contE + 1 }
            });  
            pfcF.c = contC;
            pfcF.e = contE;
            pfcF.t = contC + contE;
          });
        });

        let pasoE:any = [];
        let pasoC:any = [];
        get().pfcDominioStore.map((pfc:any, indexPfc:any) => {
          pasoE = [];
          pasoC = [];
          pfc.pfcAgrupado.map((pfcAgr:any, indexPfcAgr:any) => {
              //console.log ('pfcAgr..',pfcAgr)
              pfcAgr.arreglo.map((arr:any, indexArr:any) => {
                  if (arr.sent) { pasoC.push(pfcAgr) } 
                  else  { pasoE.push(pfcAgr) }
              });  
          }); 
          pfc.pfcAgrupadoE =  _.uniq(pasoE); 
          pfc.pfcAgrupadoC =  _.uniq(pasoC);

          pfc.pfcAgrupado.map((pfcAgr:any, indexAgrupado:any) => { pfcAgr.id = indexAgrupado });
          //pfc.pfcAgrupadoC.map((pfcAgrC:any, indexAgrupadoC:any) => { pfcAgrC.id = indexAgrupadoC });
          //pfc.pfcAgrupadoE.map((pfcAgrE:any, indexAgrE:any) => { pfcAgrE.id = indexAgrE });
          pfc.pfcAgrupadoT = pfc.pfcAgrupado;


        });
       
        //console.log (':::::::::pfcDominioStore: ',  get().pfcDominioStore );
      },

      cambiaIndiceStore: async (opc:any) => {
        //alert('entro...' + opc);
        get().pfcDominioStore.map((pfc:any, indexPfc:any) => {
          if (opc=='T') { pfc.pfcAgrupado.map((pfcAgr:any, indexAgrupado:any) => { pfcAgr.id = indexAgrupado });  pfc.pfcAgrupadoT = pfc.pfcAgrupado; }
          if (opc=='C') {pfc.pfcAgrupadoC.map((pfcAgrC:any, indexAgrupadoC:any) => { pfcAgrC.id = indexAgrupadoC }) }
          if (opc=='E') {pfc.pfcAgrupadoE.map((pfcAgrE:any, indexAgrE:any) => { pfcAgrE.id = indexAgrE }) }
        });
        //console.log ('xxxxx:::::::::pfcDominioStore: ',  get().pfcDominioStore );

      },

      filtraPFC: async( opc:any) => {
        var _ = require('underscore');
        //variables para contar cuantas hay Concluidas o en proceso para la presentación de los radios    
          let contE = 0;
          let contC = 0;

        //variables para agrupar por pfc y dejar en pfc.arregloFiltrado
          let pfcArregloFiltradoPaso:any = {};  
          let arregloFiltrado:any = [];
          let arregloElemFiltrado:any = {'id':0, 'pfcNombre':'', 'abierto':false, 'arreglo':[], 'arregloDetalles':[],'t':0, 'e':0, 'c':0 };
          let clavesFiltrado:any = {};
          let claveF = '';
        
          get().pfcDominioStore.map((pfc:any, indexPfc:any) => {
            //agrupamos pfc
            pfcArregloFiltradoPaso = {};  
            pfcArregloFiltradoPaso = _.groupBy(pfc.pfcAgrupado, 'pfcNombre'); 
            clavesFiltrado = Object.keys(pfcArregloFiltradoPaso); // claves = {"pfcNombre", "pfcNombre", "pfcNombre", ... };
            arregloFiltrado = [];
            if (clavesFiltrado.length > 0) {
                for (let i=0; i < clavesFiltrado.length; i++) {
                    arregloElemFiltrado = { 'id':0, 'pfcNombre':'', 'abierto':false, 'arreglo':[], 'arregloDetalles':[], 't':0, 'e':0, 'c':0 };
                    claveF = clavesFiltrado[i];
                    arregloElemFiltrado = { 'id':i, 'pfcNombre':claveF, 'abierto':false, 'arreglo':pfcArregloFiltradoPaso[claveF], 'arregloDetalles':[], 't':0, 'e':contE, 'c':contC  }
                    arregloFiltrado.push(arregloElemFiltrado);
                }
                if (opc==null) { pfc.pfcAgrupado = arregloFiltrado}
                if (opc=='E')  { pfc.pfcAgrupadoE = arregloFiltrado; }
                if (opc=='C')  { pfc.pfcAgrupadoC = arregloFiltrado;}
            }

          });

      },

      cambiaPfcDominioStore: async ( idpfcD:any, idpfcA:any,  datos:any, dondeViene:any ) => { 
        //alert('cambiaPfcDominioStore - idpfc:' +  idpfc + ' parametro: ' + parametro + ' dondeViene: ' + dondeViene)
        //console.clear();
        //console.log('**cambiaPfcDominioStore- idpfcD: ', idpfcD , ' -idpfcA: ', idpfcA , ' -parametro: ', datos, ' -dondeViene: ', dondeViene);
        var _ = require('underscore');
        switch (dondeViene){
          case 'abreCierraDominio':  
                get().pfcDominioStore.map((pfcD:any, pfcIndex:any) => {
                  if (pfcD.id==idpfcD) { pfcD.abierto = !pfcD.abierto }
                }); 
          break;
          case 'abreCierraPFCTodos': 
                get().pfcDominioStore.map((pfcD:any, pfcIndex:any) => {
                  pfcD.pfcAgrupado.map((pfcA:any, indexpfcA:any) => {  
                    pfcA.abierto = false;   
                  });  
                }); 
                //console.log('abreCierraPFCTodos');
          break;
          case 'abreCierraPFC':  
                get().pfcDominioStore.map((pfcD:any, pfcIndex:any) => {
                  if (pfcD.id==idpfcD) {
                      pfcD.pfcAgrupado.map((pfcA:any, indexpfcA:any) => {  
                        if (pfcA.id==idpfcA) { pfcA.abierto = !pfcA.abierto }  
                      });  
                  }    
                }); 
          break;
          case 'armaArregloDetalle':  
              get().pfcDominioStore.map((pfcD:any, IndexpfcD:any) => {
                if (pfcD.id==idpfcD) {
                    pfcD.pfcAgrupado.map((pfcA:any, indexpfcA:any) => {  
                      if (pfcA.id==idpfcA) {
                          pfcA.abierto = !pfcA.abierto;
                          pfcA.arregloDetalles = get().pfcAgrupadoDetallesStore;
                      }  
                    });  
                }    
              }); 
          break;
          case 'cambiaRadioFiltro':  
              //console.log('paso');
            
              switch (datos) {
                case 'T':
                    get().pfcTStore=true;   get().pfcDStore= false;  get().pfcCStore = false;
                    get().generaPfcDominioStore(get().pfcStore);
                break;
                case 'D': 
                    get().pfcTStore=false; get().pfcDStore= true;  get().pfcCStore = false; 
                    let pasoD = [];
                    pasoD = _.filter(get().pfcStore, function(c:any){return !c.sent})
                    get().generaPfcDominioStore(pasoD);
                break;
                case 'C':
                    let pasoC:any = [];
                    get().pfcTStore=false; get().pfcDStore= false; get().pfcCStore = true;  
                    pasoC = _.filter(get().pfcStore, function(c:any){return c.sent})
                    get().generaPfcDominioStore(pasoC);
                break;
                default:  
                    get().pfcTStore=true;   get().pfcDStore= false;  get().pfcCStore = false;
                    get().generaPfcDominioStore(get().pfcStore);
                break;
              }
          break;
        } 
        //console.log ('::::::::::::::::pfcDominioStore: ', get().pfcDominioStore );
      },
  
  pfcAgrupadoDetallesStore:[], //integramos las lecturas de  GetDetailbyUser de los elementos acumulados de pfc

      limpiaPfcAgrupadoDetallesStore: async (responseAPI:any) => {
        set ( { pfcAgrupadoDetallesStore: [] } );
      },

  pfcDetallesStore:{},
  pfcDetallesVaciaStore:{ sent: true,  id: 0, cyclename: '', 
    decision: [],
    proposal: [],
    files: [],
    evidence: [],
    acronym: '',
    frequencyname: '',
    processname: '',
    domainid: 0,
    domainname: '',
    state_process: { pt_state: 0, pt_state_description: '', onwaiting: true, leftdays: 0 },
    domainacronym: ''
  },
      //*Tareas: GetDetailbyUser  // recibe los detalles de la unidad de análisis (pfc) seleccionada //  idprop:any, tipo:any, catD:any, catP:any, catC:any, catE:any
      guardaGetDetailbyUserStore: async (responseAPI:any, idD:any, idA:any, catD:any) => { 

        //console.log('responseAPI', responseAPI);
        //console.log(' idD:', idD, ' idA:', idA)
        var _ = require('underscore');
        if (responseAPI.ret==1) { //sin error
            set ( { pfcDetallesStore: get().pfcDetallesVaciaStore } ) 
            set ( { pfcDetallesStore: responseAPI.item } )
            
            //agregamos elementos extras para manejo del front
              get().pfcDetallesStore.abierto = true;
              //para ver etiqueta de activo en la ventana sp
              let paso = get().pfcDetallesStore.state_process;
              //console.log(':::::::::::::paso',paso)
              get().pfcDetallesStore.estatusProceso = paso.pt_state_description;
              get().pfcDetallesStore.clasexEstatusIcono = "";
              switch ( paso.pt_state ) {
                case 1: get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
                case 2: get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
                case 3: get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
                case 4: get().pfcDetallesStore.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
                default: get().pfcDetallesStore.clasexEstatusIcono= "claseEstatus claseEstatusAct"; break;
              }
      
              get().pfcDetallesStore.textoDecision = '';
              get().pfcDetallesStore.textoDecisionExcel = '';
              get().pfcDetallesStore.decision.map((dec:any, indexDec:any) => {
                  catD.map((catD:any, indexCatD:any) => {
                    if (dec == catD.id) {  
                        get().pfcDetallesStore.textoDecision = get().pfcDetallesStore.textoDecision + '<i class="mdi mdi mdi-checkbox-marked-circle colorOrange1"></i>' + catD.name + ' ';
                        get().pfcDetallesStore.textoDecisionExcel = get().pfcDetallesStore.textoDecisionExcel + catD.name + ' ';
                    }
                  });
              });
              get().pfcDetallesStore.numEvidencias = get().pfcDetallesStore.evidence.length;

              //para poner los letreros (Reporte y/o Justificación) dentro de la columna Reporte de pruebas
              get().pfcDetallesStore.swProof = false;
              get().pfcDetallesStore.swJustify = false;
              if (get().pfcDetallesStore.files.length> 0) {
                get().pfcDetallesStore.files.map((f:any, indexF:any) => {
                    f.path =  f.path +  '\\' ;  
                    if (f.name!=null && f.name !=''){
                        f.nombreCorto= ( f.name.length > 8) ?  f.name.substring(0,8) + '...' : f.name; 
                        if (f.classified=='PROOF') { get().pfcDetallesStore.swProof=true }
                        if (f.classified=='JUSTIFY') { get().pfcDetallesStore.swJustify=true }
                    }
                })
              }

              get().pfcAgrupadoDetallesStore.push (get().pfcDetallesStore);

              get().pfcDominioStore[idD].pfcAgrupado[idA].arregloDetalles.push (get().pfcDetallesStore);
              
              //get().pfcDominioStore[idD].pfcAgrupadoT[idA].arregloDetalles.push (get().pfcDetallesStore);
             /*  get().pfcDominioStore.map((pfc:any, indexPfc:any) => {
                    pfc.pfcAgrupadoT = pfc.pfcAgrupado;
              }); */
              
            //console.log (':::pfcAgrupadoDetallesStore: ', get().pfcAgrupadoDetallesStore );
            console.log ('getDetail----:pfcDominioStore: ',  get().pfcDominioStore );
            //console.log ('xxxxx:::::::::pfcDominioStore: ',  get().pfcDominioStore );
          return(get().pfcDetallesStore);
        }
        else {
            get().generaObjErrorDecisionsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'dashboard.store-guardaGetDetailbyUserStore')
        }
      },

  radioFiltroStore: [
    {id:'T', texto:'Todos', activo:true},
    {id:'E', texto:'En proceso de documentación', activo:false},
    {id:'C', texto:'Concluido', activo:false}
  ],  
  radioFiltroSelStore: 'T'  ,

    cambiaRadioFiltroStore: async ( opc:any) => {
      set ( { radioFiltroSelStore: opc} );
      get().radioFiltroStore.map((rf:any, indexRF:any) => {
        if (rf.id == opc) { rf.activo = true }    
        else { rf.activo = false }
      });
      
      get().pfcDominioStore.map((pfc:any, indexPfc:any) => {
          if (opc=='T') { pfc.pfcAgrupado = pfc.pfcAgrupadoT };
          if (opc=='E') { pfc.pfcAgrupado = pfc.pfcAgrupadoE };
          if (opc=='C') { pfc.pfcAgrupado = pfc.pfcAgrupadoC };
      });

      //console.clear();
      //console.log ('cambiaRadio---------------:::pfcDominioStore: ',  get().pfcDominioStore );
      //console.log('::::::::radioFiltroStore::', get().radioFiltroStore);
    },
  
    recargaStore: async ( opc:any) => {
      console.log('voy por recarga')
    }
}));

export default dashboardStore;
